import Box from '@eversports/klimt-primitives/legacy/Box'
import Heading from '@eversports/klimt-primitives/legacy/Heading'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import { useParams } from 'react-router-dom'

import { useNotFoundCityQuery, useNotFoundCitySearchQuery } from '../../../../graphql'
import useGetTopContentHeight from '../../../../hooks/useGetTopContentHeight'
import { Localized } from '../../../../localization/react'

import NoResults from './assets/NoResults.svg'
import OnlineOfferings from './OnlineOfferings'
import OtherCities from './OtherCities'
import OtherSports from './OtherSports'

const NotFound = () => {
  const { DESKTOP_TOP_CONTENT_HEIGHT: TOP_CONTENT_HEIGHT } = useGetTopContentHeight(['NAVIGATION_BAR'])
  const { sportSlug, citySlug } = useParams<{ citySlug: string; sportSlug?: string }>()
  const { data: cityData, error: cityDataError } = useNotFoundCityQuery({ variables: { slug: citySlug } })
  const { data: citySearchData } = useNotFoundCitySearchQuery({ skip: Boolean(sportSlug) })

  const showOtherSports = sportSlug && cityData && !cityDataError && cityData.city.popularSports.length > 0
  const showCityOtherCities = citySearchData && citySearchData.citySearch.length > 0

  return (
    <Stack
      gap={18}
      backgroundColor="limelite"
      justifyContent={{ md: 'center' }}
      alignItems={{ md: 'center' }}
      paddingX={6}
      paddingY={12}
      height={`calc(100vh - ${TOP_CONTENT_HEIGHT}px)`}
    >
      <Stack justifyContent="center" alignItems="center" gap={4}>
        <Box component="img" src={NoResults} alt="" width={{ xs: '50px', md: '70px' }} />
        <Heading is="h1" color="midnight" textAlign="center" variant="large">
          {sportSlug ? (
            <Localized id="discover-no-results-sport-city" params={{ sportSlug, citySlug }} />
          ) : (
            <Localized id="discover-no-results-city" params={{ citySlug }} />
          )}
        </Heading>
        <Text>
          <Localized id="discover-no-results-description" />
        </Text>
      </Stack>
      {showOtherSports ? (
        <OtherSports cityData={cityData.city} />
      ) : (
        showCityOtherCities && <OtherCities cities={citySearchData.citySearch} />
      )}
      <OnlineOfferings />
    </Stack>
  )
}

export default NotFound
